import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';

export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <nav
      className={`fixed left-0 right-0 top-0 z-[100] transition-all duration-300 ${
        isScrolled
          ? 'border-b border-[rgba(11,13,16,0.08)] bg-[#F6F5F2]/90 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between px-8 py-4">
        {/* Logo */}
        <Link
          to="/"
          className="font-display text-xl font-bold text-[#0B0D10] transition-colors hover:text-[#E1062C]"
        >
          Duly Cited
        </Link>

        {/* Right Side */}
        <div className="flex items-center gap-4">
          {user ? (
            <>
              <span className="hidden text-sm text-[#6B7280] sm:block">{user.email}</span>
              <Link
                to="/app"
                className="text-sm font-medium text-[#0B0D10] transition-colors hover:text-[#E1062C]"
              >
                Dashboard
              </Link>
              <button
                onClick={handleSignOut}
                className="text-sm font-medium text-[#0B0D10] transition-colors hover:text-[#E1062C]"
              >
                Sign out
              </button>
            </>
          ) : (
            <>
              <Link
                to="/signin"
                className="font-medium text-[#0B0D10] transition-colors hover:text-[#E1062C]"
              >
                Sign in
              </Link>
              <Button
                asChild
                className="btn-hover rounded-full bg-[#E1062C] px-4 py-2 text-sm font-medium text-white hover:bg-[#c00525]"
              >
                <Link to="/signup">Get the app</Link>
              </Button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
